import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import ReactTable from 'react-table'
import {
  Div, H3, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import './style-css.css'
import { Wrapper } from '../../../components/job-components'
import { JOB_LIST } from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import PERMISSION from '../../../constants/permissions'
import ROLE from '../../../constants/role'
import { MobileJobList } from './mobile'

const { color } = theme

let refetchTimeout = null

const anotherModelArr = [
  'Customer.companyId',
  'Customer.companyName',
  'Customer.typeOfCharge',
]
const mappingAnotherModelValue = (v) => {
  if (v.id === 'Customer.TypeOfCharge.id') {
    return {
      typeOfChargeId: v.value,
    }
  }
  if (anotherModelArr.indexOf(v.id) >= 0) {
    const split = v.id.split('.')
    return split[1] ? {
      [split[1]]: v.value,
    } : { [v.id]: v.value }
  }
  return { [v.id]: v.value }
}
const mappingOrderAnotherModel = (sortValue) => {
  if (anotherModelArr.indexOf(sortValue.id) >= 0) {
    const split = sortValue.id.split('.')
    return split[1] ? {
      id: `${split[0]}${split[1]}`,
      desc: sortValue.desc,
    } : { id: sortValue.id, desc: sortValue.desc }
  }
  return { id: sortValue.id, desc: sortValue.desc }
}

const Index = () => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (myInfo.myInfo.Roles[0].id === ROLE.CUSTOMER.id) return <CustomerJobList />
  return <JobList />
}

const JobList = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายการสัญญางาน</H3>
      <DynamicButtonLink link='/job/add' condition={_.includes(window.perms, PERMISSION.CREATE_JOB)} props={{ text: 'สร้างสัญญางาน' }}/>
    </Div>
    <List />
  </Div>
)

const CustomerJobList = () => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return (
  <Div display='flex' flexDirection='column'>
    {
        width > 768
        ? <Div>
          <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
            <H3 bold color={color.primaryColor} margin='32px 0'>รายการสัญญางาน</H3>
          </Div>
          <List isCustomer={true}/>
          </Div>
        : <MobileJobList />
      }
  </Div>
  )
}

export const List = (props) => {
  const [filtered, setFiltered] = useState([])
  const [sorted, setSorted] = useState([{ id: 'createdAt', desc: true }])
  const [current, setCurrent] = useState(0)
  return (
  <Wrapper overflow padding='0 0 40px 0' center>
    <Query
        query={JOB_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            <ReactTable
            className='table'
            data={data.JobList.lists} // *
            resizable={false}
            columns={props.isCustomer ? config.customerColumns : config.columns} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            // getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            noDataText='ไม่พบข้อมูล'
            page={current}
            pages={Math.ceil(data.JobList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const mapObj = newFiltered.map(v => mappingAnotherModelValue(v))
                .reduce((prev, curr) => ({ ...prev, ...curr }), {})
              clearTimeout(refetchTimeout)
              refetchTimeout = setTimeout(() => {
                setFiltered(mapObj)
              }, 750)
              setCurrent(0)
            }}
            onSortedChange={async (newSorted) => {
              const sortValue = newSorted[0]
              const mappingNewSort = mappingOrderAnotherModel(sortValue)
              setSorted([mappingNewSort])
              setCurrent(0)
            }}
          />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
    </Query>
  </Wrapper>)
}


export default Index
